import {Utility} from "./Utility";
import moment = require("moment");

export enum FormatTypes {
	PRICE = "Price",
	DATE = "Date",
	DATETIME = "DateTime"
}

export class Formater {

	static format (data: any, type: FormatTypes): any {

		switch (type) {
			case FormatTypes.PRICE:
				return Formater.formatPrice(data, 2)
			case FormatTypes.DATE:
				return Formater.formatDate(data)
			case FormatTypes.DATETIME:
				return Formater.formatDateTime(data)
			default:
				return data
		}
	}

	static formatDate(value: Date) {
		if (!value) return '-'
		return moment(value).format("YYYY-MM-DD")
	}

	static formatDateTime(value: Date) {
		if (!value) return '-'
		return moment(value).format("YYYY-MM-DD hh:mm")
	}

	static formatPrice(value: number, decimals: number): string{
		//Handle null and undefined
		if(value == null){
			return '-';
		}

		if(typeof value !== 'number' ) {
			try {
				value = parseFloat(value)
			} catch (e) {
				console.log("Invalid price format: " + value)
				return '-';
			}
		}

		let roundedValue = decimals != null ? Formater.roundOnDecimals(value, decimals) : value;
		return Formater.addZerosToEnd(Formater.formatNumberWithCommas(roundedValue), ",", 2);
	}

	//Inspired by: http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
	private static formatNumberWithCommas(value: number) :string {
		var parts = value.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
		return parts.join(",");
	}

	//Inspired by: http://www.jacklmoore.com/notes/rounding-in-javascript/
	private static roundOnDecimals(value: number, decimals: number): number {
		return Number(Math.round(<any>(value+'e'+decimals))+'e-'+decimals);
	}

	private static addZerosToEnd(value: string, separator: string, numberOfZeros:number) {

		if (value === "NaN") value = "0"

		if (value.indexOf(separator) == -1) return value + separator + "00";

		var zerosToAdd = numberOfZeros - (value.length - value.indexOf(separator));

		for (var i=0; i<=zerosToAdd; i++) {
			value = value += "0";
		}

		return value;
	}
}
